import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getUserList} from '../../../apis/user/getUserList'

const PAGE_SIZE = 10

const useQueryUserList = (name?: string, currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.user.getUserList(),
        staleTime: 60 * 1000,
        queryFn: async () => {
            const data = await getUserList(PAGE_SIZE, currentPage, name)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryUserList
